import React, { Suspense, useState, useEffect } from 'react'
import { HiArrowNarrowRight } from 'react-icons/hi'
import { Link } from 'react-scroll'
import PropTypes from 'prop-types'
import me_320 from '../assets/me_320.webp'
import me_640 from '../assets/me_640.webp'
import me_1024 from '../assets/me_1024.webp'
const SliderCard = React.lazy(() => import('./SocialViewer'))
const SocilaLinks = React.lazy(() => import('./SocialLinks'))
const Home = ({ content }) => {
  const [isContentLoaded, setIsContentLoaded] = useState(false)
  const [imageSrc, setImageSrc] = useState(me_1024) // Default image
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 575.98) {
        setImageSrc(me_320)
      } else if (window.innerWidth <= 1200) {
        setImageSrc(me_640)
      } else {
        setImageSrc(me_1024)
      }
    }

    // Set initial image source based on window size
    handleResize()

    // Update image source on window resize
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (content && content.fields.landing_caption && content.fields.landing_main_text) {
      setIsContentLoaded(true)
    }
  }, [content])

  return (
    <div
      id='about'
      name='home'
      className='min-h-screen pt-20 text-gray-300 bg-gradient-to-l from-cyan-600 to-cyan-800'
    >
      <div className='mx-auto p-4 sm:p-16 grid lg:grid-cols-2'>
        {!isContentLoaded && (
          <div className='flex items-center justify-center h-full'>
            <p>Loading...</p>
          </div>
        )}
        {isContentLoaded && (
          <>
            <div className='justify-left pr-20 py-8'>
              <div>
                <h2 className='text-lg'>{content.fields.landing_caption}</h2>
                <div className='font-bold text-4xl'>
                  <div className='inline-block'>{content.fields.landing_main_text}</div>
                  <div className='inline-block pl-2'>
                    <span className='relative flex h-2 w-2'>
                      <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75'></span>
                      <span className='relative inline-flex rounded-full h-2 w-3 bg-sky-500'></span>
                    </span>
                  </div>
                </div>
                <p className='text-lg'>{content.fields.landing_main_details}</p>
              </div>
              <div>
                <p className='text-lg break-words pt-4'>{content.fields.landing_main_more}</p>
                <Link
                  to='contact'
                  smooth
                  duration={500}
                  className='text-base group w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer'
                  href='#contact'
                >
                  Reachout to me
                  <HiArrowNarrowRight
                    size={25}
                    className='ml-3 group-hover:rotate-90 duration-300'
                  />
                </Link>
              </div>
            </div>
            <div className='justify-left lg:px-8 '>
              <div className='overflow-hidden w-full object-cover'>
                <img src={imageSrc} alt='My Profile - Albin Issac' className='profile-image' />
              </div>
            </div>
          </>
        )}
      </div>
      <div className='mx-auto px-4 md:px-16 grid lg:grid-cols-2'>
        <div className='w-auto'>
          <div className='text-left'>
            <h3 className='text-3xl font-bold border-b-2 border-cyan-500'>Latest Posts</h3>
          </div>
          <div name='posts' id='posts' className='pt-4 mx-auto'>
            <Suspense fallback={<div>Loading...</div>}>
              <SliderCard />
            </Suspense>
          </div>
        </div>
        <div className='justify-center'>
          <div name='followme' className='flex flex-col justify-center items-center'>
            <div className='container mx-auto pt-10 md:pt-0 lg:pl-20'>
              <div className='text-left'>
                <h3 className='text-3xl font-bold border-b-2 border-cyan-500'>Follow Me</h3>
              </div>
              <div className='pt-4'>
                <Suspense fallback={<div>Loading...</div>}>
                  <SocilaLinks />
                </Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Home.propTypes = {
  content: PropTypes.object
}

export default Home
